const features = [
  {
    title: '近期最热古装大剧《凤隐天下》',
    desc: '权谋纷争与虐恋交织，全网热度破亿，演技派阵容倾情演绎，服化道精良堪称年度标杆。',
    tag: '热播榜首',
    tagColor: 'bg-primary-500 text-background-50',
    image: 'https://readdy.ai/api/search-image?query=ancient%20chinese%20costume%20drama%20scene%20with%20elegant%20characters%20in%20traditional%20hanfu%2C%20palace%20interior%20with%20warm%20candlelight%2C%20dramatic%20cinematic%20lighting%2C%20soft%20gold%20and%20crimson%20tones%2C%20atmospheric%20mist%2C%20emotional%20intensity%2C%20high%20quality%20film%20photography&width=800&height=500&seq=carousel-01-2026&orientation=landscape',
  },
  {
    title: '韩国高分悬疑《镜像追踪》',
    desc: '烧脑反转不断，每集结尾都让人惊掉下巴，豆瓣评分飙至9.1，年度口碑神剧之一。',
    tag: '口碑推荐',
    tagColor: 'bg-accent-500 text-background-50',
    image: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20thriller%20scene%20with%20intense%20detective%20in%20dark%20alley%2C%20rain%2C%20neon%20reflections%20on%20wet%20pavement%2C%20noir%20cinematography%2C%20dramatic%20shadows%2C%20suspenseful%20atmosphere%2C%20cold%20blue%20and%20amber%20contrast%20lighting&width=800&height=500&seq=carousel-02-2026&orientation=landscape',
  },
  {
    title: '国产动画电影《山海秘境》',
    desc: '东方奇幻世界观搭配顶级3D视效，票房突破30亿，国产动画新高度不容错过。',
    tag: '票房冠军',
    tagColor: 'bg-primary-500 text-background-50',
    image: 'https://readdy.ai/api/search-image?query=chinese%20animated%20fantasy%20film%20scene%20with%20mythical%20creatures%20in%20misty%20mountains%2C%20vibrant%20colors%2C%20flowing%20energy%20and%20magic%20particles%2C%20epic%20landscape%20with%20ancient%20temples%2C%20dreamlike%20atmosphere%2C%20cinematic%203D%20animation%20style&width=800&height=500&seq=carousel-03-2026&orientation=landscape',
  },
  {
    title: '美剧回归《暗夜边境》第五季',
    desc: '末日科幻史诗重磅回归，制作规模再升级，全球同步追剧中，每一帧都是电影质感。',
    tag: '新季上线',
    tagColor: 'bg-accent-500 text-background-50',
    image: 'https://readdy.ai/api/search-image?query=dystopian%20sci-fi%20landscape%20with%20futuristic%20city%20ruins%20at%20sunset%2C%20dramatic%20orange%20sky%2C%20survivors%20silhouettes%2C%20epic%20scale%2C%20atmospheric%20dust%20and%20light%20rays%2C%20cinematic%20wide%20shot%2C%20high%20production%20value&width=800&height=500&seq=carousel-04-2026&orientation=landscape',
  },
  {
    title: '治愈系日剧《面包和汤和猫咪》',
    desc: '温暖治愈的生活小品，一集入魂的慢节奏美学，在喧嚣中找回内心的宁静与柔软。',
    tag: '治愈精选',
    tagColor: 'bg-secondary-500 text-background-50',
    image: 'https://readdy.ai/api/search-image?query=cozy%20Japanese%20bakery%20shop%20interior%20with%20warm%20sunlight%20streaming%20through%20windows%2C%20fresh%20bread%20on%20wooden%20counter%2C%20a%20calm%20cat%20sleeping%20nearby%2C%20minimalist%20aesthetic%2C%20soft%20natural%20lighting%2C%20peaceful%20atmosphere%2C%20film-like%20photography&width=800&height=500&seq=carousel-05-2026&orientation=landscape',
  },
  {
    title: '国产谍战剧《无声暗战》',
    desc: '民国谍战题材新标杆，剧情环环相扣多次反转，老戏骨飙戏场面张力拉满，越看越上头。',
    tag: '高分力荐',
    tagColor: 'bg-primary-500 text-background-50',
    image: 'https://readdy.ai/api/search-image?query=1940s%20Chinese%20republican%20era%20spy%20thriller%20scene%2C%20man%20in%20trench%20coat%20under%20dim%20streetlamp%20in%20old%20Shanghai%20alley%2C%20rainy%20night%2C%20vintage%20atmosphere%2C%20noir%20lighting%2C%20mysterious%20shadows%2C%20cinematic%20composition&width=800&height=500&seq=carousel-06-2026&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          焦点推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-[480px] mx-auto">
          编辑精选的优质影视内容，不用挑直接看
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((item) => (
            <article
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden h-[200px]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className={`absolute top-3 left-3 px-2.5 py-1 rounded-full text-[10px] font-semibold ${item.tagColor}`}>
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 leading-snug mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}